module.exports = __webpack_public_path__ + "0f0c38a9e01ed3f7aa8cea8e0d10a9fa.png";